/** @returns {boolean} True when VITE_USE_BOX_LABELS_V2 is set to "true". */
export function isBoxLabelsV2Enabled() {
    try {
        return String(import.meta.env?.VITE_USE_BOX_LABELS_V2 ?? "").toLowerCase() === "true"
    } catch {
        return false
    }
}

/**
 * Whether to use HTML print-dialog box labels (v2) for the current context.
 * Requires the env gate; when a location has use_print_dialog, that setting chooses v2 vs PDF (v1).
 *
 * @param {{ locations?: any[], locationId?: number | string | null }} [options]
 * @returns {boolean}
 */
export function shouldUseBoxLabelsV2({ locations = [], locationId = null } = {}) {
    if (!isBoxLabelsV2Enabled()) {
        return false
    }

    if (locationId == null || !locations?.length) {
        return true
    }

    const location = locations.find((loc) => Number(loc.id) === Number(locationId))
    if (location == null) {
        return true
    }

    if (Object.prototype.hasOwnProperty.call(location, "use_print_dialog")) {
        return Boolean(location.use_print_dialog)
    }

    return true
}
